export enum FormPresence {
    CREATE = 'CREATE',
    UPDATE = 'UPDATE',
    ALL = 'ALL',
}
